angular.module('aq.filters').filter('filterByIds', function() {
    return function(list, ids) {
        return list.filter(function(result) {
            return _.includes(ids, result.id);
        });
    }
});